// extracted by mini-css-extract-plugin
export default {"innerCard":"Timer_innerCard__kU2J-","timeInput":"Timer_timeInput__XjEGh","footer":"Timer_footer__8SHrF"};